import { Components, Theme } from '@mui/material/styles'

/**
 * ## `text.primary`, not `primary.contrastText`
 *
 * `contrastText` is the colour legible ON the primary colour — i.e. on a
 * primary-FILLED surface. A link is not on one; it sits in body copy. `primary.main`
 * defaults to BLACK (`./palette.ts`), so MUI computed `contrastText` as `#fff` and a
 * plain `<Link>` painted white on the white pages this app is made of.
 *
 * ## Nothing is white on screen today — and the reason is the tell
 *
 * Measured in the browser: EVERY `MuiLink` rule emitted by this theme carries the
 * literal `color:#fff`, and every one of them is saved only by a trailing
 * `color:inherit` from the call site's `color='inherit'` prop, which emotion appends
 * to the SAME rule and which therefore wins on declaration order. All six live
 * `<Link>` call sites in `apps/app` pass it — `LegalDocumentDrawer` (×2),
 * `PhoneVerificationDrawer` (×2), `CreateAccountEmail`, `Help/ArticlePage` (×2).
 * Measured on `/create-account`: `rgb(0,0,0)` on white (21:1) and `rgb(112,112,112)`
 * on white (4.95:1).
 *
 * A default that every legible call site has to opt out of is the wrong default
 * (working-conventions §47): the first `<Link>` written without `color='inherit'`
 * renders pure white and nothing warns you. `text.primary` is the palette entry
 * carrying a legibility contract — `theme.text_color || '#000000'`, the colour the
 * tenant designated as readable body text on their own background — so it degrades
 * to "the same colour as the prose around it" rather than to "invisible".
 *
 * Existing call sites are unaffected: `color='inherit'` still lands last and still wins.
 */
export const MuiLink: Components<Theme>['MuiLink'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontSize: '14px',
      fontWeight: 600,
      '&:active, &:hover': {
        textDecoration: 'underline',
      },
    }),
  },
}
